import { SignaturesConstants } from '../store/signatures.constants'

export const signaturesSchemas = [
  {
    inputKey: SignaturesConstants.SET_SECTION_TWO_REASON_INCAPABLE_OF_SIGNING,
    isNumber: false,
    type: 'object',
    properties: {
      SET_SECTION_TWO_REASON_INCAPABLE_OF_SIGNING: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,99}$',
      },
    },
    additionalProperties: false,
    required: ['SET_SECTION_TWO_REASON_INCAPABLE_OF_SIGNING'],
    errorMessage: {
      properties: {
        SET_SECTION_TWO_REASON_INCAPABLE_OF_SIGNING: 'Must be alphanumeric with max length of 100',
      },
    },
  },
  {
    inputKey: SignaturesConstants.SET_SECTION_THREE_REASON_INCAPABLE_OF_SIGNING,
    isNumber: false,
    type: 'object',
    properties: {
      SET_SECTION_THREE_REASON_INCAPABLE_OF_SIGNING: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,99}$',
      },
    },
    additionalProperties: false,
    required: ['SET_SECTION_THREE_REASON_INCAPABLE_OF_SIGNING'],
    errorMessage: {
      properties: {
        SET_SECTION_THREE_REASON_INCAPABLE_OF_SIGNING: 'Must be alphanumeric with max length of 100',
      },
    },
  },
]
